import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';

@Component({
  selector: 'custom-toggle',
  templateUrl: './custom-toggle.component.html',
  styleUrls: ['./custom-toggle.component.scss']
})

 

export class CustomToggleComponent implements OnInit {
 /* @ViewChild("toglleElement") element: ElementRef;*/
  @Output() ChangeValue: EventEmitter<any> = new EventEmitter();
  @Input()   Value: any;

 
  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
  }
  toggle() {
      let newvalue = 0;
      if (this.Value == 1)
          newvalue =0;
      else
          newvalue=1
    this.Value = newvalue;
 
    //this.element.nativeElement.classList.toggle("checked");
    //this.element.nativeElement.classList.toggle("unchecked");
   this.ChangeValue.emit(newvalue);

  }

   


}
